export default __webpack_public_path__ + "static/media/electric guitar coutry slide 120bpm - B.230fcab8.mp3";